import React from 'react';
import classes from "./MediumLoader.module.css";

const MediumLoader = () => {
  return (
    <div className={classes.loader_container}>
        <span className={classes.loader} ></span>
    </div>

  )
}

export default MediumLoader